export enum AccessType {
  CustUser = "user",
  UserAdmin = "useradmin",
  Keurmeister = "keurmeister",
  Admin = "admin",
  custProductMover = "customerproductmover",
  Transporter = "transporter",
}
